/* Svensk katalog for locale-closing-focused-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'clo.focus.finalConfirmation': 'Jag har kontrollerat underlaget, händelser i eget kapital, efterföljande händelser och fortsatt drift. Alla nödvändiga konteringar och bedömningar är klargjorda. Jag godkänner att året avslutas. Godkännare och tidpunkt sparas i historiken.',
  'clo.focus.approve': 'Godkänn',
  'clo.focus.startYear': 'Startår för bokföringen',
  'clo.focus.bankSetupMissing': 'Registrera startdatum och dokumenterat startsaldo i kontoinställningarna nedan. Skriv 0 om saldot var noll.',
  'clo.focus.bankStatements': 'Kontoutdrag saknas för perioderna',
  'clo.focus.bankUnsettled': 'Perioder måste stämmas av',
  'clo.focus.bankDifferences': 'Saldoavvikelser måste klargöras i bankavstämningen.',
  'clo.focus.bankUnconfigured': 'Skapa bankkonto med rätt bokföringskonto för dessa bokförda saldon',
  'clo.focus.reconcile': 'Slutför avstämning',
  'clo.focus.restore': 'Återställ storlek',
  'clo.focus.fullscreen': 'Helskärm',
  'clo.focus.notCalculated': 'Inte beräknat',
  'clo.focus.taxScope': 'Klargör skatteregim',
  'clo.focus.rateHelp': 'Ordinarie norsk bolagsskatt är 22 % från 2019. Bekräfta skatteregimen innan beräkningen kan godkännas. Finansskatt och särskilda regimer kräver separat bedömning.',
  'clo.focus.industry': 'Skatteregim',
  'clo.focus.ordinary': 'Ordinarie skatteregim',
  'clo.focus.special': 'Särskild regim – kräver bedömning',
  'clo.focus.finance': 'Finansskattepliktig',
  'clo.focus.priorLoss': 'Underskott att föra vidare från tidigare år (bekräfta även 0)',
  'clo.focus.updateCalculation': 'Spara och beräkna',
  'clo.focus.taxCalculation': 'Så beräknas skatten',
  'clo.focus.resultBeforeTax': 'Resultat före skatt',
  'clo.focus.permanent': '+ Permanenta skillnader (netto)',
  'clo.focus.temporaryChange': '− Förändring i temporära skillnader',
  'clo.focus.lossApplied': '− Utnyttjat underskott från tidigare år',
  'clo.focus.taxable': '= Skatteunderlag',
  'clo.focus.rate': 'Skattesats',
  'clo.focus.resolveRate': 'Klargör skatteregim ovan',
  'clo.focus.payable': '= Betalbar skatt',
  'clo.focus.lossRemaining': 'Underskott att föra vidare',
  'clo.focus.deferredTax': 'Uppskjuten skatt / skattefordran',
  'clo.focus.temporary': 'Temporära skillnader',
  'clo.focus.unrecognized': 'Ej redovisad skattefordran (underlag)',
  'clo.focus.deferredBasis': 'Underlag för uppskjuten skatt',
  'clo.focus.deferredAmount': 'Uppskjuten skatt / skattefordran',
  'clo.focus.postingApproval': 'Godkänn beräkning och slutkontering',
  'clo.focus.postingHelp': 'Godkännandet bekräftar att du har kontrollerat skatteunderlag, skillnader och underskott att föra vidare. Betalbar skatt och eventuell förändring i uppskjuten skatt bokförs vid avslutet av räkenskapsåret. Redan bokförda belopp beaktas av slutkonteringen.',
  'clo.focus.postingAccounts': 'Beräknad betalbar skatt: debet 8300 / kredit 2500',
  'clo.focus.reviewRequired': 'Skatteregim eller särskilda skatteförhållanden måste klargöras före godkännande.',
  'clo.focus.unsaved': 'Spara och beräkna efter ändringar innan du godkänner.',
  'clo.focus.editDifferences': 'Ändra skillnader och specifikationer',
  'clo.checklist.custom.mappedDetail': 'Inga konton saknar koppling till Plummes standardkontoplan. Importerade konton kontrolleras när de ingår i kontoplanen. Detta är ingen kontroll av hela skattemelding-kopplingen.',
  'clo.priorYear.closedDetail': 'Räkenskapsåret {{year}} är avslutat.',
  'clo.priorYear.noActivity': 'Inga redovisningssiffror har registrerats för {{year}} i Plumme. Startåret ensamt avgör inte om föregående år måste avslutas.',
});
